import { atom } from 'jotai';
import z from 'zod';

export const ZCartId = z.string();

export type CartIdAtom = z.infer<typeof ZCartId>;

export const cartIdAtom = atom<z.infer<typeof ZCartId> | undefined>(undefined);
